var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table-view',{attrs:{"column-keys":_vm.columnKeys,"loading":_vm.loading,"items":_vm.list,"header":_vm.header},on:{"changePage":_vm.changePage,"cellEvent":_vm.cellEvent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }